export default __webpack_public_path__ + "static/media/017.2eb3810b.webp";